import selfieImg from '@assets/svg/selfie.svg'
import { Button } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import './onboarding-mediakit.component.scoped.scss'

interface Props {
  setShowOmboarding: (event: any) => any
}

export default ({ setShowOmboarding }: Props) => {
  const [t] = useTranslation('onboardingMediaKit')
  let img = <img src={selfieImg} className="img-fluid" alt="Selfie-Icon" title="SelfieImage" />

  const handleClick = () => {
    if (setShowOmboarding && typeof setShowOmboarding === 'function') {
      setShowOmboarding(false)
    }
  }

  return (
    <div className="onboarding-media-kit ">
      <div className="onboarding-media-kit-content">
        <h4 dangerouslySetInnerHTML={{ __html: t('title') }} />
        <figure>{img}</figure>
        <div className="onboarding-media-kit-text">
          <p dangerouslySetInnerHTML={{ __html: t('text') }} />
        </div>
        <div className="onboarding-media-kit-button">
          <Button
            onClick={() => handleClick()}
            style={{ maxWidth: '200px' }}
            width="100%"
            color="var(--primary_color)"
            borderColor="var(--primary_color)"
            textColor="var(--secondary_color)"
            size="lg"
            rounded={true}
          >
            {t('button')}
          </Button>
        </div>
      </div>
    </div>
  )
}
